var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.reportIndividualData)?_c('div',{staticClass:"mt-5"},[_c('VTable',{staticClass:"mt-5 mb-5",attrs:{"data":_vm.tableData}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }